import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toastIfError } from '../../../utils/toast';
import { browserDownload, EmvioLoadingSpinner } from '@nexio/emvio-util-ui';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import './PdfActions.scss';

export default class PdfActions extends Component {
    static propTypes = {
        error: PropTypes.string,
        filename: PropTypes.string,
        isPdfLoading: PropTypes.bool,
        onGetPdf: PropTypes.func,
        pdfData: PropTypes.string,
        shouldControlAction: PropTypes.bool,
        shouldControlToast: PropTypes.bool,
        useIcons: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.renderButtonsOrLoading = this.renderButtonsOrLoading.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    componentDidUpdate(previousProps) {
        if (this.props.shouldControlToast) {
            toastIfError(previousProps, this.props);
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'pdfData') && this.props.shouldControlAction) {
            const filename = `${this.props.filename}.pdf`;

            browserDownload(filename, this.props.pdfData, 'application/pdf');
        }
    }

    handleDownload() {
        this.props.onGetPdf();
    }

    renderButtonsOrLoading() {
        if (this.props.isPdfLoading) {
            return <EmvioLoadingSpinner isRelative size="small"/>;
        } else if (this.props.useIcons) {
            return <span
                className="icon-down"
                title="Download"
                onClick={this.handleDownload}/>;
        } else {
            return <a href="#" onClick={this.handleDownload}>Download</a>;
        }
    }

    render() {
        return (
            <div className="pdf-actions-wrapper">
                {this.renderButtonsOrLoading()}
            </div>
        );
    }
}
